export const ROUTER_UPDATE_PARAMS = 'ROUTER_UPDATE_PARAMS';
export const ROUTER_NAVIGATE_URL = 'ROUTER_NAVIGATE_URL';
